/**
 * Classse d'utilitaires divers
 * Si une fonction peut être utiles pour une autre projet, on met ici
 */
export default class Utils {

    constructor()
    {
        //this.debug('Utils : construct')
    }
    static isTouch()
    {

        var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));

        return isTouch
    }

    static isMobile()
    {

        return (window.innerWidth <= 810)
    }


    static desktopBurger(){
      return (window.innerWidth <= 1220)
    }

    /**
     * Check if IE
     * @returns {boolean}
     */
    static isIE()
    {
        let ua = window.navigator.userAgent;
        return /MSIE|Trident/.test(ua)
    }

    static getTranslateXY(element)
    {
        const style = window.getComputedStyle(element)
        const matrix = new DOMMatrixReadOnly(style.transform)
        return {
            translateX: matrix.m41,
            translateY: matrix.m42,
        }
    }
    static getTranslateValues(element)
    {
        const style = window.getComputedStyle(element)
        const matrix = style['transform'] || style.webkitTransform || style.mozTransform

        // No transform property. Simply return 0 values.
        if (matrix === 'none') {
            return {
                x: 0,
                y: 0,
                z: 0,
            }
        }

        // Can either be 2d or 3d transform
        const matrixType = matrix.includes('3d') ? '3d' : '2d'
        const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

        // 2d matrices have 6 values
        // Last 2 values are X and Y.
        // 2d matrices does not have Z value.
        if (matrixType === '2d') {
            return {
                x: matrixValues[4],
                y: matrixValues[5],
                z: 0,
            }
        }

        // 3d matrices have 16 values
        // The 13th, 14th, and 15th values are X, Y, and Z
        if (matrixType === '3d') {
            return {
                x: matrixValues[12],
                y: matrixValues[13],
                z: matrixValues[14],
            }
        }
    }

    /**
     * Recherche si l'élément est présent dans le DOM
     * @param {Element} el
     * @returns {boolean}
     */
    static isDOM(el)
    {
        let flag = el instanceof Element;
        if (flag) {
            flag = document.body.contains(el);
        }
        return flag;
    }

    /**
     * Recherche si on est sur Safari ou non
     * @returns {boolean}
     */
    static isSafari()
    {
        return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    }

    /**
     *
     */
    static copyrights()
    {
        if (console !== undefined) {
            console.log('');
            console.log('%c Devs by Pistil Studio', 'background: #ff4d6d; color: #fbf2e8; padding: 5px');
            console.log('');
        }
    }


    /**
     *
     * @param element
     * @returns {*|number}
     */
    static getTranslateY(element)
    {
        var style = window.getComputedStyle(element.get(0));
        var matrix = style.getPropertyValue('-webkit-transform') || style.getPropertyValue('-moz-transform') || style.getPropertyValue('-ms-transform') || style.getPropertyValue('-o-transform') || style.getPropertyValue('transform');
        if (matrix === 'none') {
            matrix = 'matrix(0,0,0,0,0)';
        }
      // eslint-disable-next-line no-useless-escape
        var values = matrix.match(/([-+]?[\d\.]+)/g);
        return parseFloat(values[14]) || parseFloat(values[5]) || 0;
    }

    /**
     *
     * @param element
     * @returns {*|number}
     */
    static  getTranslateX(element)
    {
        var style = window.getComputedStyle(element);
      // eslint-disable-next-line no-undef
        var matrix = new WebKitCSSMatrix(style.transform);
        console.log('translateX: ', matrix.m41);
        return matrix.m41
    }

    /**
     *
     * @param msg
     */
    static debug(msg)
    {
        if (console !== undefined) {
            //console.log(msg);
        }
    }



    static isTabOrMobile()
    {
      // eslint-disable-next-line no-undef
        let w = Verge.viewportW();
        if (w <= 1024) {
            return true;
        } else {
            return false;
        }
    }

    static isIe()
    {

        let ua = window.navigator.userAgent;

        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        let trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        let edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    }


    /**
     *
     * @param cname
     * @param cvalue
     * @param exdays
     */
    static setCookie(cname, cvalue, exdays)
    {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = 'expires='+ d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }


    /**
     *
     * @param cname
     * @returns {*}
     */
    static getCookie(cname)
    {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }


    static disabledHover()
    {

        var touch = 'ontouchstart' in document.documentElement
            || navigator.maxTouchPoints > 0
            || navigator.msMaxTouchPoints > 0;

        if (touch) { // remove all :hover stylesheets
            try { // prevent exception on browsers not supporting DOM styleSheets properly
                for (var si in document.styleSheets) {
                    var styleSheet = document.styleSheets[si];
                    if (!styleSheet.rules) {
                        continue;
                    }

                    for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                        if (!styleSheet.rules[ri].selectorText) {
                            continue;
                        }

                        if (styleSheet.rules[ri].selectorText.match(':hover')) {
                            styleSheet.deleteRule(ri);
                        }
                    }
                }
              // eslint-disable-next-line no-empty
            } catch (ex) {
            }
        } else {
            $('body').addClass('noTouch');
        }
    }


}



// WEBPACK FOOTER //
// ./scripts/utils/utils.js